import { useMedia } from '@/hooks/content/media';
import { Media } from '@cinemark/content-api-client';
import type { SerializedUploadNode } from '@payloadcms/richtext-lexical';
import Image from 'next/image';

type RichTextUploadConverterComponentProps = {
  node: SerializedUploadNode | undefined;
};

export const RichTextUploadConverterComponent = ({ node }: RichTextUploadConverterComponentProps): React.JSX.Element | null => {
  const mediaDoc = node?.value && typeof node.value === 'object' ? node.value as Media : null;
  const { data: media, isLoading } = useMedia(mediaDoc?.id || '');

  const getAlignmentStyle = (alignment: string): string => {
    switch (alignment) {
      case 'center': return 'justify-self-center';
      case 'right': return 'justify-self-end';
      default: return 'justify-self-start';
    }
  };

  if (!node || node.relationTo !== 'media' || typeof node.value !== 'object') return null;

  const alignmentClass = getAlignmentStyle(node.fields?.alignment);

  if (isLoading || !media) {
    return <Image alt="/img/poster_blank.jpg"
      className={alignmentClass}
      height={100}
      src="/img/poster_blank.jpg"
      width={100}
    />;
  }

  return <Image alt={media.filename || 'img'}
    className={alignmentClass}
    height={media.height}
    src={media.url || '/img/poster_blank.jpg'}
    width={media.width}
  />;
};
